
import React, { useState } from 'react';
import { AuthPaymentCard } from '@/components/courier/AuthPaymentCard';
import { PaymentInfo } from '@/hooks/useCourierPayments';
import { useAuthPayment } from '@/contexts/AuthPaymentContext';
import { toast } from '@/components/ui/sonner';

interface AuthPaymentSectionProps {
  // Этот компонент теперь не принимает authPayment напрямую,
  // а использует AuthPaymentContext
}

export const AuthPaymentSection: React.FC<AuthPaymentSectionProps> = () => {
  const { authPayment, refreshAuthPayment } = useAuthPayment();
  const [loading, setLoading] = useState(false);

  const handleAuthorizePayment = async (payment: PaymentInfo) => {
    try {
      setLoading(true);
      
      toast.info('Подготовка авторизации карты...', {
        description: 'Пожалуйста, подождите',
        duration: 3000
      });
      
      // ВАЖНО: Используем единый формат URL для редиректа
      // Единообразие в формате URL позволит избежать проблем при определении статуса платежа
      const returnUrl = `${window.location.origin}/payment/auth/status?courier_id=${payment.courierId}`;
      
      // Формируем URL для авторизационного платежа
      const authUrl = `https://yoomoney.ru/checkout/payments/v2/contract?orderId=${payment.id}&returnUrl=${encodeURIComponent(returnUrl)}`;
      
      // Показываем уведомление о том, что авторизация открывается в новом окне
      toast.info('Авторизация карты открывается в новом окне', {
        description: 'Пожалуйста, разрешите всплывающие окна в браузере',
        duration: 5000
      });
      
      // Открываем авторизацию в новом окне
      const authWindow = window.open(authUrl, '_blank');
      
      if (!authWindow) {
        toast.error('Не удалось открыть окно авторизации', {
          description: 'Проверьте настройки блокировки всплывающих окон в браузере'
        });
        setLoading(false);
        return;
      }
      
      // Обновляем состояние контекста через небольшую задержку
      setTimeout(async () => {
        await refreshAuthPayment();
        setLoading(false);
      }, 3000);
      
    } catch (error) {
      console.error('Ошибка при авторизации карты:', error);
      toast.error('Произошла ошибка при подготовке авторизации карты', {
        description: 'Пожалуйста, попробуйте позже'
      });
      setLoading(false);
    }
  };

  // Если нет авторизационного платежа, не отображаем компонент
  if (!authPayment) return null;

  return (
    <div className="mb-6">
      <AuthPaymentCard 
        authPayment={authPayment}
        onAuthorize={handleAuthorizePayment}
        loading={loading}
      />
    </div>
  );
};
